/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseDTOAvailableUserStatesResponseDTO } from '../models/ApiResponseDTOAvailableUserStatesResponseDTO';
import type { ApiResponseDTODigitalAddressVerificationResponseDTO } from '../models/ApiResponseDTODigitalAddressVerificationResponseDTO';
import type { ApiResponseDTOListAllCountryDTO } from '../models/ApiResponseDTOListAllCountryDTO';
import type { ApiResponseDTOListCountrySummarizedDTO } from '../models/ApiResponseDTOListCountrySummarizedDTO';
import type { ApiResponseDTOListLocalGovernmentResponseDTO } from '../models/ApiResponseDTOListLocalGovernmentResponseDTO';
import type { ApiResponseDTOListString } from '../models/ApiResponseDTOListString';
import type { ApiResponseDTOSoftPOSResponse } from '../models/ApiResponseDTOSoftPOSResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ResourceApiService {

    /**
     * Get all countries
     * Every country and territory in ISO 3166-1, by name, with its alpha-2 and alpha-3 codes and its international dialling code. No authentication required.
     * @returns ApiResponseDTOListAllCountryDTO OK
     * @throws ApiError
     */
    public static getAllCountries(): CancelablePromise<ApiResponseDTOListAllCountryDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/all-countries',
            errors: {
                400: `Bad Request`,
                403: `Forbidden`,
                404: `Not Found`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get countries
     * Get the list of countries
     * @param countryName
     * @param countryCode
     * @param countryCallingCode
     * @returns ApiResponseDTOListCountrySummarizedDTO OK
     * @throws ApiError
     */
    public static getCountries(
        countryName?: string,
        countryCode?: string,
        countryCallingCode?: string,
    ): CancelablePromise<ApiResponseDTOListCountrySummarizedDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/countries',
            query: {
                'countryName': countryName,
                'countryCode': countryCode,
                'countryCallingCode': countryCallingCode,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Validate Digital Address
     * Validate a digital address
     * @param digitalAddress
     * @returns ApiResponseDTODigitalAddressVerificationResponseDTO OK
     * @throws ApiError
     */
    public static validateDigitalAddress(
        digitalAddress: string,
    ): CancelablePromise<ApiResponseDTODigitalAddressVerificationResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/digital-address/{digitalAddress}',
            path: {
                'digitalAddress': digitalAddress,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get industries
     * Get the list of industries
     * @returns ApiResponseDTOListString OK
     * @throws ApiError
     */
    public static getListOfIndustries(): CancelablePromise<ApiResponseDTOListString> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/industry',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get local government area
     * Get the list of local government areas
     * @param state
     * @returns ApiResponseDTOListLocalGovernmentResponseDTO OK
     * @throws ApiError
     */
    public static getLocalGovernment(
        state: string,
    ): CancelablePromise<ApiResponseDTOListLocalGovernmentResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/local-government-areas',
            query: {
                'state': state,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get states
     * Get the list of states
     * @returns ApiResponseDTOAvailableUserStatesResponseDTO OK
     * @throws ApiError
     */
    public static getAvailableStates(): CancelablePromise<ApiResponseDTOAvailableUserStatesResponseDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/resource/states',
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * Get Soft POS terminal
     * Endpoint to retrieve soft POS terminal for activated devices
     * @param countryCode
     * @param merchantId
     * @returns ApiResponseDTOSoftPOSResponse OK
     * @throws ApiError
     */
    public static getSoftPosDetails(
        countryCode: string,
        merchantId: string,
    ): CancelablePromise<ApiResponseDTOSoftPOSResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/soft-pos/{countryCode}/soft-pos-details',
            path: {
                'countryCode': countryCode,
            },
            query: {
                'merchantId': merchantId,
            },
            errors: {
                403: `Forbidden`,
                422: `Unprocessable Entity`,
                501: `Not Implemented`,
            },
        });
    }

}
